import React from 'react'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
const VendorRatingButtons = () => {
    const navigate = useNavigate()
    return (
        <div className="submit_btns">
            <Button
                type="button"
                className="cancelBtn"
                onClick={() => navigate("/vendor-rating-list")}
            >
                Back
            </Button>
        </div>
    )
}

export default VendorRatingButtons